import React, { useContext, useState } from 'react';
import { Form, Icon, Image } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import { FormContext } from '../../../cnr/contexts/FormContext';
import { gEnums } from '../../../enums/globalEnums';
import { appIconTypes } from '../../../enums/appIconTypes';
import { ColorPicker } from './ColorPicker';
import { propHelpers } from '../../../common/tester';
import { FormItemContext } from '../FormItem';
import { TimeSelector } from './TimeSelector';

const FormInput = () => {

  // FormContext
  const { form_state = {}, form_handlers = {} } = useContext(FormContext) ?? {};
  const { data_localForm } = form_state;
  const { handlePropPush, handleItemAdd } = form_handlers;

  // FormItemContext
  const { formItem_state = {} } = useContext(FormItemContext) ?? {};
  const { fip = {}, fipProps = {}, itemProp = {}, themeColors } = formItem_state;
  const { prop, key: key_prop, data = {} } = itemProp;
  const { regUrl } = fipProps;

  const propKey = prop || key_prop

  const { formItemType, dataType, urlLink, urlSheetsLink, hasImageUrl, eventUpdateLink, saveLink, autoFill, hasAddIcon, pushToOthers, highlighted } = data;
  const { propname, otype } = fip;
  const isColor = propname?.toLowerCase().includes('color');

  let disabled = false

  switch (formItemType) {
    case 'textReadOnly':
      disabled = true;
      break;
    default:
    // nothing
  }

  // Form value
  const formValue = data_localForm?.[propKey] ?? '';
  const _fip = { ...fip, value: formValue };
  delete _fip.value;
  delete _fip.key;

  _fip.value = formValue

  const [showPw, setShowPw] = useState(false);
  const items = [];

  // Helper functions
  const renderIcon = (name, color = 'blue', onClick) => (
    <Icon key={uniqueKey('fii-r', propname, name)} name={name} color={color} style={{ float: 'right' }} onClick={onClick} />
  );

  const renderFormInput = (props = {}) => <Form.Input disabled={disabled} key={uniqueKey('fi', propname)} {..._fip} {...props} fluid />;

  // Early returns for specific input types
  if (propHelpers.isTimeProp(propname)) {
    return <TimeSelector fip={_fip} itemProp={itemProp} />;
  }

  if (isColor) {
    return <ColorPicker key={uniqueKey('fi', propname)} fip={_fip} themeColors={themeColors} />;
  }

  // Conditional rendering based on data attributes 
  if (urlLink) {
    items.push(renderIcon(appIconTypes.externalAlternate, 'blue', () => window.open(urlLink, '_blank')));
    items.push(renderIcon(_fip.value ? _fip.value : 'question circle', _fip.value ? 'green' : 'grey'));
    items.push(renderFormInput());
  } else if (urlSheetsLink) {
    items.push(renderIcon(appIconTypes.externalAlternate, 'blue', () => window.open(urlSheetsLink + _fip.value, '_blank')));
    items.push(renderFormInput());
  } else if (eventUpdateLink) {
    items.push(renderIcon(appIconTypes.arrowRight, 'blue', () => window.open(regUrl + _fip.value, '_blank')));
    items.push(renderFormInput());
  } else if (saveLink) {
    items.push(renderIcon('save', 'blue', () => alert('Save this')));
    items.push(renderFormInput());
  } else if (autoFill) {
    items.push(renderFormInput({ disabled: true }));
  } else if (pushToOthers) {
    _fip.width = 14;
    items.push(
      <Form.Group>
        {renderFormInput()}
        <Form.Button key={uniqueKey('fii-pto', propname)} icon="copy" style={{ marginTop: '1.75em' }} onClick={handlePropPush} />
      </Form.Group>
    );
  } else if (hasAddIcon) {
    _fip.width = 14;
    items.push(
      <Form.Group>
        {renderFormInput()}
        <Form.Button key={uniqueKey('fii-hai', propname)} icon={appIconTypes.add} style={{ marginTop: '1.75em' }} onClick={handleItemAdd} />
      </Form.Group>
    );
  } else if (hasImageUrl) {
    items.push(renderFormInput());
    if (_fip.value) {
      items.push(<Image src={_fip.value} />);
    }
  } else if (otype === 'password') {
    _fip.type = showPw ? 'text' : 'password';
    items.push(renderIcon(showPw ? 'eye' : 'eye slash', undefined, () => setShowPw(!showPw)));
    items.push(renderFormInput({ autoComplete: 'new-password' }));
  } else {
    switch (dataType) {
      case gEnums.dataTypes.currency:
        items.push(renderFormInput({ icon: 'dollar', iconPosition: 'left' }));
        break;
      case gEnums.dataTypes.number:
        items.push(renderFormInput({ icon: 'hashtag', iconPosition: 'left' }));
        break;
      default:
        items.push(renderFormInput());
    }
  }

  if (highlighted) {
    items.unshift(renderIcon('user secret', 'green'));
  }

  return items;
};

export default FormInput;
